import React from 'react'
import { DatePicker } from '@common/material/DatePicker'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { Box, Flex } from '@fundamentals'
import moment from 'moment/moment'
import { Controller, useFormContext } from 'react-hook-form'

export const RegisterItemDatePropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = ({ property, registerItem, sx, disabled }) => {
  const { control } = useFormContext()

  const isDisabled =
    disabled || (!!registerItem && property.lockedAfterCreation)

  return (
    <Box
      sx={{
        '.react-datepicker__input-container input': {
          height: 'auto',
          background: 'none',
          border: 'none!important',
          color: 'inherit!important',
        },
        flexGrow: 1,
      }}
    >
      <Flex alignItems='center'>
        <Controller
          name={`${property.id}`}
          rules={{
            validate: (value) => !!value?.dateValue || !property.required,
          }}
          control={control}
          render={({ field, formState: { errors } }) => (
            <DatePicker
              UTC
              withClearButton
              dataTest={`${property.type}-${property.name}`}
              value={
                field.value?.dateValue ? moment(field.value.dateValue) : null
              }
              onChange={(date) =>
                field.onChange({
                  ...property,
                  registerPropertyId: property.id,
                  dateValue: date ? date.toISOString() : '',
                })
              }
              required={property.required}
              error={!!Object.keys(errors).includes(`${property.id}`)}
              disabled={isDisabled}
              sx={{
                mb: 2,
                width: '100%',
                ...sx,
              }}
              label={property.name}
            />
          )}
        />
      </Flex>
    </Box>
  )
}
